module.exports = __webpack_public_path__ + "static/media/img-heritage-area4-hashinotekkouzan.c31f987a.jpg";